import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  timeout: 10000,
});

const CognitoAPI = axios.create({
  baseURL: process.env.REACT_APP_BASE_COGNITO_URL,
  timeout: 10000,
});

const FormsAPI = axios.create({
  baseURL: process.env.REACT_APP_BASE_FORMS_URL,
  timeout: 10000,
});

async function apiGet(endpoint, params, history) {
  try {
    const response = await API.get(endpoint, params);
    if (response.data.auth === false) {
      throw new Error(response.data.message || response.data);
    } else if (response.data === "no token or invalid token error ") {
      history.push({
        pathname: "/login",
        state: { message: "Your session has expired. Please log in again." },
      });
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error in apiGet:", error);
    history.push({
      pathname: "/login",
      state: { message: "Your session has expired. Please log in again." },
    });
  }
}

export { API, CognitoAPI, FormsAPI, apiGet };
